//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { GruposContext } from "../context/GruposContext";


//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ContainerGroups() {


    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { groups, setGroups } = useContext(GruposContext);
    const { isOpenModalEditGroup, setIsOpenModalEditGroup } = useContext(GruposContext);
    const { isOpenModalDeleteGroup, setIsOpenModalDeleteGroup } = useContext(GruposContext);
    const { formDataModalEditGroup, setFormDataModalEditGroup } = useContext(GruposContext);
    const { formDataModalDeleteGroup, setFormDataModalDeleteGroup } = useContext(GruposContext);



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV QUE CONTÊM OS GRUPOS */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                {groups.map(group => (
                    <>


                        {/* DIV GRUPO */}
                        <div key={group.id} className="bg-surface-2 rounded-xl p-4 border flex flex-col border-white/[0.08]">


                            {/* DIV CABEÇALHO DO GRUPO */}
                            <div className="flex justify-between">

                                {/* NOME DO GRUPO */}
                                <h2 className="font-semibold text-lg">{group.nome}</h2>

                                {/* DIV BUTTONS DO GRUPO QUE APARECE SOMENTE QUANDO A LARGURA DA TELA É SUPERIOR A 1080px */}
                                <div className="hidden gap-2 lg:flex">
                                    {/* BUTTON EDITAR */}
                                    <button onClick={() => {
                                        setIsOpenModalEditGroup(true)
                                        setFormDataModalEditGroup({ group: group })
                                    }} className="bg-blue-600 px-2 py-1 rounded">Editar</button>
                                    {/* BUTTON EXCLUIR */}
                                    <button onClick={() => {
                                        setIsOpenModalDeleteGroup(true);
                                        setFormDataModalDeleteGroup({ id: group.id });
                                    }} className="bg-red-600 px-2 py-1 rounded">Excluir</button>
                                </div>

                            </div>


                            {/* DADOS DO GRUPO */}
                            <ul className="mt-2 mb-6 space-y-1">
                                {group.produtos.map(p => (
                                    <li key={p.id}>{p.nome} (ID: {p.id_produto_hotmart || p.id_produto_kiwify || p.id_produto_lastlink})</li>
                                ))}
                            </ul>


                            {/* DIV BUTTON DO GRUPO QUE APARECE SOMENTE QUANDO A LARGURA DA TELA É INFERIOR A 1080px */}
                            <div className="flex gap-2 lg:hidden mt-auto">
                                <button onClick={() => {
                                    setIsOpenModalEditGroup(true);
                                    setFormDataModalEditGroup({ group: group });
                                }} className="bg-blue-600 px-2 py-1 rounded">Editar</button>
                                <button onClick={() => {
                                    setIsOpenModalDeleteGroup(true);
                                    setFormDataModalDeleteGroup({ id: group.id });
                                }} className="bg-red-600 px-2 py-1 rounded">Excluir</button>
                            </div>
                        </div>


                    </>
                ))}
            </div>

        </>
    )
}